module.exports = __webpack_public_path__ + "static/media/story_01.fdd5769f.jpg";